import React, { useState, useCallback, useRef } from 'react';
import './AdminReportes.css';
import {
  BarChart, Bar, LineChart, Line, PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  Area, AreaChart,
} from 'recharts';
import * as XLSX from 'xlsx';           // ← compila?
import jsPDF from 'jspdf';              // ← compila?
import autoTable from 'jspdf-autotable';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';

/* ── Icons ── */
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconExcel    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="10 9 9 9 8 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPDF      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconChevL    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevR    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconTrend    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="17 6 23 6 23 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconTrendDn  = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="23 18 13.5 8.5 8.5 13.5 1 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="17 18 23 18 23 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const COLORES_ESTADO = {
  validado:       '#4db88a',
  pendiente:      '#f59e0b',
  voucher_enviado:'#3b82f6',
  rechazado:      '#ef4444',
  reembolsado:    '#8b5cf6',
};
const ESTADO_LABEL = {
  validado:'Validado', pendiente:'Pendiente',
  voucher_enviado:'Con voucher', rechazado:'Rechazado', reembolsado:'Reembolsado',
};
const PIE_COLORS = ['#4db88a','#f59e0b','#3b82f6','#ef4444','#8b5cf6','#6b7280'];
const RANGOS_RAPIDOS = [
  { label:'Hoy',       desde: () => f(new Date()), hasta: () => f(new Date()) },
  { label:'Esta semana', desde: () => { const d=new Date(); d.setDate(d.getDate()-d.getDay()+1); return f(d); }, hasta: () => f(new Date()) },
  { label:'Este mes',  desde: () => f(new Date(new Date().getFullYear(), new Date().getMonth(), 1)), hasta: () => f(new Date()) },
  { label:'Últ. 30d',  desde: () => { const d=new Date(); d.setDate(d.getDate()-29); return f(d); }, hasta: () => f(new Date()) },
  { label:'Últ. 90d',  desde: () => { const d=new Date(); d.setDate(d.getDate()-89); return f(d); }, hasta: () => f(new Date()) },
  { label:'Este año',  desde: () => `${new Date().getFullYear()}-01-01`, hasta: () => f(new Date()) },
];

function f(d) { return d.toISOString().split('T')[0]; }
function fmtS(n) { return 'S/. ' + parseFloat(n||0).toLocaleString('es-PE', {minimumFractionDigits:2, maximumFractionDigits:2}); }
function fmtN(n) { return parseInt(n||0).toLocaleString('es-PE'); }
function fmtPct(n) { return (n >= 0 ? '+' : '') + n + '%'; }
function fmtDia(d) {
  if (!d) return '';
  const [,m,dd] = d.split('-');
  const meses = ['','Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  return `${parseInt(dd)} ${meses[parseInt(m)]}`;
}

export default function AdminReportes() {
  const hoy = f(new Date());
  const inicioMes = f(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

  const [desde,      setDesde]      = useState(inicioMes);
  const [hasta,      setHasta]      = useState(hoy);
  const [estadoFil,  setEstadoFil]  = useState('todos');
  const [rangoActivo,setRangoActivo]= useState('Este mes');
  const [datos,      setDatos]      = useState(null);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState(null);
  const [busTabla,   setBusTabla]   = useState('');
  const [pagina,     setPagina]     = useState(1);
  const [porPagina]                 = useState(15);
  const [exportando, setExportando] = useState(false);
  const reporteRef = useRef(null);

  const fetchReporte = useCallback(async (d = desde, h = hasta, est = estadoFil) => {
    setLoading(true); setError(null);
    try {
      const r = await fetch(`${API}?action=reporte_gerencial&desde=${d}&hasta=${h}&estado=${est}`);
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setDatos(j.data);
      setPagina(1);
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  }, [desde, hasta, estadoFil]);

  function aplicarRango(rango) {
    const d = rango.desde();
    const h = rango.hasta();
    setDesde(d); setHasta(h); setRangoActivo(rango.label);
    fetchReporte(d, h, estadoFil);
  }

  /* ── Exportar Excel ── */
  async function exportarExcel() {
    if (!datos) return;
    setExportando(true);
    try {
      const wb = XLSX.utils.book_new();

      // Hoja KPIs
      const kpiData = [
        ['Métrica', 'Valor'],
        ['Período', `${datos.periodo.desde} al ${datos.periodo.hasta}`],
        ['Ingresos totales (validados)', datos.kpi.ingresos_total],
        ['Total pedidos', datos.kpi.total_pedidos],
        ['Pedidos validados', datos.kpi.validados],
        ['Pedidos pendientes', datos.kpi.pendientes],
        ['Con voucher', datos.kpi.voucher_enviado],
        ['Rechazados', datos.kpi.rechazados],
        ['Tasa de conversión (%)', datos.kpi.tasa_conversion],
        ['Ticket promedio', datos.kpi.ticket_promedio],
        ['Clientes únicos', datos.kpi.clientes_unicos],
      ];
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(kpiData), 'KPIs');

      // Hoja pedidos
      const pedidosCols = ['Código','Cliente','Email','Teléfono','Producto','Monto','Descuento','Estado','Método','Referencia','Fecha','Validado'];
      const pedidosRows = datos.pedidos.map(p => [
        p.codigo, p.nombre, p.email, p.telefono||'',
        p.recurso_titulo, p.monto, p.descuento_puntos||0,
        p.estado, p.metodo_pago||'', p.referencia_pago||'',
        p.created_at, p.validado_at||'',
      ]);
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([pedidosCols,...pedidosRows]), 'Pedidos');

      // Hoja top productos
      const prodCols = ['Producto','Ventas','Ingresos','Precio promedio','% del total'];
      const prodRows = datos.top_productos.map(p => [p.titulo, p.ventas, p.ingresos, p.precio_prom, p.pct]);
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([prodCols,...prodRows]), 'Top productos');

      // Hoja por día
      const diaCols = ['Fecha','Pedidos','Ingresos','Validados','Pendientes','Rechazados'];
      const diaRows = datos.por_dia.map(d => [d.dia, d.pedidos, d.ingresos, d.validados, d.pendientes, d.rechazados]);
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([diaCols,...diaRows]), 'Por día');

      XLSX.writeFile(wb, `reporte_comunicar_${desde}_${hasta}.xlsx`);
    } catch(e) { alert('Error al exportar: ' + e.message); }
    finally { setExportando(false); }
  }

  /* ── Exportar PDF ── */
  async function exportarPDF() {
    if (!datos) return;
    setExportando(true);
    try {
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

      // Cabecera
      doc.setFillColor(17, 22, 20);
      doc.rect(0, 0, 210, 28, 'F');
      doc.setTextColor(130, 216, 179);
      doc.setFontSize(16); doc.setFont('helvetica','bold');
      doc.text('Comunicar — Reporte Gerencial', 14, 12);
      doc.setFontSize(9); doc.setFont('helvetica','normal');
      doc.setTextColor(180, 200, 190);
      doc.text(`Período: ${datos.periodo.desde} al ${datos.periodo.hasta}   ·   Generado: ${new Date().toLocaleDateString('es-PE')}`, 14, 20);

      // KPIs
      doc.setTextColor(17, 22, 20);
      doc.setFontSize(11); doc.setFont('helvetica','bold');
      doc.text('Resumen ejecutivo', 14, 38);

      autoTable(doc, {
        startY: 42,
        head: [['Métrica', 'Valor']],
        body: [
          ['Ingresos totales (validados)', fmtS(datos.kpi.ingresos_total)],
          ['Total pedidos', fmtN(datos.kpi.total_pedidos)],
          ['Pedidos validados', fmtN(datos.kpi.validados)],
          ['Pedidos pendientes', fmtN(datos.kpi.pendientes)],
          ['Con voucher enviado', fmtN(datos.kpi.voucher_enviado)],
          ['Rechazados', fmtN(datos.kpi.rechazados)],
          ['Tasa de conversión', datos.kpi.tasa_conversion + '%'],
          ['Ticket promedio', fmtS(datos.kpi.ticket_promedio)],
          ['Clientes únicos', fmtN(datos.kpi.clientes_unicos)],
        ],
        headStyles: { fillColor:[17,22,20], textColor:[130,216,179], fontStyle:'bold' },
        alternateRowStyles: { fillColor:[243,248,245] },
        margin: { left:14, right:14 },
      });

      // Top productos
      const y1 = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(11); doc.setFont('helvetica','bold');
      doc.text('Top productos', 14, y1);
      autoTable(doc, {
        startY: y1 + 4,
        head: [['Producto','Ventas','Ingresos','% Total']],
        body: datos.top_productos.map(p => [p.titulo, p.ventas, fmtS(p.ingresos), p.pct+'%']),
        headStyles: { fillColor:[17,22,20], textColor:[130,216,179], fontStyle:'bold' },
        alternateRowStyles: { fillColor:[243,248,245] },
        margin: { left:14, right:14 },
      });

      // Detalle pedidos (página nueva)
      doc.addPage();
      doc.setFillColor(17, 22, 20);
      doc.rect(0, 0, 210, 18, 'F');
      doc.setTextColor(130, 216, 179);
      doc.setFontSize(12); doc.setFont('helvetica','bold');
      doc.text('Detalle de pedidos', 14, 12);

      autoTable(doc, {
        startY: 24,
        head: [['Código','Cliente','Producto','Monto','Estado','Fecha']],
        body: datos.pedidos.map(p => [
          p.codigo, p.nombre, p.recurso_titulo,
          fmtS(p.monto), ESTADO_LABEL[p.estado]||p.estado,
          p.created_at?.split('T')[0]||p.created_at||'',
        ]),
        headStyles: { fillColor:[17,22,20], textColor:[130,216,179], fontStyle:'bold' },
        alternateRowStyles: { fillColor:[243,248,245] },
        styles: { fontSize:8 },
        margin: { left:14, right:14 },
      });

      doc.save(`reporte_comunicar_${desde}_${hasta}.pdf`);
    } catch(e) { alert('Error al exportar PDF: ' + e.message); }
    finally { setExportando(false); }
  }

  /* ── Tabla filtrada ── */
  const pedidosFiltrados = (datos?.pedidos || []).filter(p => {
    const q = busTabla.toLowerCase();
    return !q || p.nombre?.toLowerCase().includes(q) || p.email?.toLowerCase().includes(q)
      || p.codigo?.toLowerCase().includes(q) || p.recurso_titulo?.toLowerCase().includes(q);
  });
  const totalPag = Math.max(1, Math.ceil(pedidosFiltrados.length / porPagina));
  const paginaSeg = Math.min(pagina, totalPag);
  const pedidosPag = pedidosFiltrados.slice((paginaSeg-1)*porPagina, paginaSeg*porPagina);

  /* ── Datos dona ── */
  const donaData = datos ? [
    { name:'Validados',     value: datos.kpi.validados,       color:'#4db88a' },
    { name:'Pendientes',    value: datos.kpi.pendientes,      color:'#f59e0b' },
    { name:'Con voucher',   value: datos.kpi.voucher_enviado, color:'#3b82f6' },
    { name:'Rechazados',    value: datos.kpi.rechazados,      color:'#ef4444' },
    { name:'Reembolsados',  value: datos.kpi.reembolsados,    color:'#8b5cf6' },
  ].filter(d => d.value > 0) : [];

  /* ── Datos acumulado ── */
  let acum = 0;
  const acumData = (datos?.por_dia || []).map(d => {
    acum += d.ingresos;
    return { ...d, acumulado: Math.round(acum * 100) / 100 };
  });

  return (
    <div className="ar-page" ref={reporteRef}>

      {/* HEADER */}
      <div className="ar-header">
        <div>
          <h1>Reporte gerencial</h1>
          <p>Análisis completo de ventas, pedidos e ingresos</p>
        </div>
        <div className="ar-header__actions">
          {datos && (
            <>
              <button className="ar-btn-export ar-btn-export--xl" onClick={exportarExcel} disabled={exportando}>
                <IconExcel/> Excel
              </button>
              <button className="ar-btn-export ar-btn-export--pdf" onClick={exportarPDF} disabled={exportando}>
                <IconPDF/> PDF
              </button>
            </>
          )}
        </div>
      </div>

      {/* FILTROS */}
      <div className="ar-filtros-card">
        {/* Rangos rápidos */}
        <div className="ar-rangos-rapidos">
          {RANGOS_RAPIDOS.map(r => (
            <button
              key={r.label}
              className={'ar-rango-btn ' + (rangoActivo===r.label?'ar-rango-btn--active':'')}
              onClick={() => aplicarRango(r)}
            >{r.label}</button>
          ))}
        </div>
        {/* Fechas personalizadas */}
        <div className="ar-fechas">
          <div className="ar-fecha-field">
            <label>Desde</label>
            <input type="date" value={desde} max={hasta} onChange={e=>{ setDesde(e.target.value); setRangoActivo(''); }}/>
          </div>
          <div className="ar-fecha-field">
            <label>Hasta</label>
            <input type="date" value={hasta} min={desde} max={hoy} onChange={e=>{ setHasta(e.target.value); setRangoActivo(''); }}/>
          </div>
          <div className="ar-fecha-field">
            <label>Estado</label>
            <select value={estadoFil} onChange={e=>setEstadoFil(e.target.value)}>
              <option value="todos">Todos</option>
              <option value="validado">Validados</option>
              <option value="pendiente">Pendientes</option>
              <option value="voucher_enviado">Con voucher</option>
              <option value="rechazado">Rechazados</option>
              <option value="reembolsado">Reembolsados</option>
            </select>
          </div>
          <button className="ar-btn-aplicar" onClick={() => fetchReporte()} disabled={loading}>
            <IconRefresh/> {loading ? 'Cargando…' : 'Aplicar'}
          </button>
        </div>
      </div>

      {/* ESTADO */}
      {!datos && !loading && !error && (
        <div className="ar-empty">
          <p>Selecciona un período y haz clic en <strong>Aplicar</strong> para generar el reporte.</p>
          <button className="ar-btn-aplicar" onClick={() => fetchReporte()}>
            <IconRefresh/> Generar reporte
          </button>
        </div>
      )}
      {loading && (
        <div className="ar-loading">
          <div className="ar-loading__spinner"/>
          <p>Generando reporte…</p>
        </div>
      )}
      {error && (
        <div className="ar-error">⚠️ {error}</div>
      )}

      {datos && !loading && (<>

        {/* ════ KPIs ════ */}
        <div className="ar-kpis">
          {/* Ingresos */}
          <div className="ar-kpi ar-kpi--grande ar-kpi--verde">
            <div className="ar-kpi__top">
              <p>Ingresos validados</p>
              <span className={'ar-var ' + (datos.kpi.var_ingresos>=0?'ar-var--pos':'ar-var--neg')}>
                {datos.kpi.var_ingresos>=0?<IconTrend/>:<IconTrendDn/>} {fmtPct(datos.kpi.var_ingresos)}
              </span>
            </div>
            <strong>{fmtS(datos.kpi.ingresos_total)}</strong>
            <span>vs {fmtS(datos.kpi.ingresos_ant)} período anterior</span>
          </div>
          {/* Pedidos */}
          <div className="ar-kpi ar-kpi--grande">
            <div className="ar-kpi__top">
              <p>Total pedidos</p>
              <span className={'ar-var ' + (datos.kpi.var_pedidos>=0?'ar-var--pos':'ar-var--neg')}>
                {datos.kpi.var_pedidos>=0?<IconTrend/>:<IconTrendDn/>} {fmtPct(datos.kpi.var_pedidos)}
              </span>
            </div>
            <strong>{fmtN(datos.kpi.total_pedidos)}</strong>
            <span>vs {fmtN(datos.kpi.pedidos_ant)} período anterior</span>
          </div>
          {/* Conversión */}
          <div className="ar-kpi">
            <p>Tasa de conversión</p>
            <strong>{datos.kpi.tasa_conversion}%</strong>
            <span>{fmtN(datos.kpi.validados)} de {fmtN(datos.kpi.total_pedidos)} pedidos</span>
          </div>
          {/* Ticket */}
          <div className="ar-kpi">
            <p>Ticket promedio</p>
            <strong>{fmtS(datos.kpi.ticket_promedio)}</strong>
            <span>por pedido validado</span>
          </div>
          {/* Por estado */}
          <div className="ar-kpi">
            <p>Pendientes</p>
            <strong style={{color:'#f59e0b'}}>{fmtN(datos.kpi.pendientes)}</strong>
            <span>por cobrar</span>
          </div>
          <div className="ar-kpi">
            <p>Con voucher</p>
            <strong style={{color:'#3b82f6'}}>{fmtN(datos.kpi.voucher_enviado)}</strong>
            <span>por validar</span>
          </div>
          <div className="ar-kpi">
            <p>Rechazados</p>
            <strong style={{color:'#ef4444'}}>{fmtN(datos.kpi.rechazados)}</strong>
            <span>en el período</span>
          </div>
          <div className="ar-kpi">
            <p>Clientes únicos</p>
            <strong>{fmtN(datos.kpi.clientes_unicos)}</strong>
            <span>con pedidos</span>
          </div>
        </div>

        {/* ════ GRÁFICAS FILA 1 ════ */}
        <div className="ar-graficas-row">
          {/* Barras: ingresos por día */}
          <div className="ar-card ar-card--wide">
            <div className="ar-card__head">
              <h3>Ingresos por día</h3>
              <span className="ar-card__sub">{datos.periodo.dias} días</span>
            </div>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={datos.por_dia} margin={{top:4,right:8,left:0,bottom:0}}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(130,216,179,.15)"/>
                <XAxis dataKey="dia" tickFormatter={fmtDia} tick={{fontSize:11,fill:'#5a6a63'}} tickLine={false}/>
                <YAxis tick={{fontSize:11,fill:'#5a6a63'}} tickLine={false} axisLine={false}
                  tickFormatter={v => 'S/.'+v.toLocaleString()}/>
                <Tooltip formatter={(v,n) => [fmtS(v), n==='ingresos'?'Ingresos':'Pedidos']}
                  labelFormatter={fmtDia} contentStyle={{borderRadius:10,border:'1px solid #d4f4e8',fontSize:12}}/>
                <Bar dataKey="ingresos" fill="#4db88a" radius={[4,4,0,0]} name="ingresos"/>
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Dona: estados */}
          <div className="ar-card">
            <div className="ar-card__head"><h3>Por estado</h3></div>
            {donaData.length > 0 ? (
              <>
                <ResponsiveContainer width="100%" height={180}>
                  <PieChart>
                    <Pie data={donaData} cx="50%" cy="50%" innerRadius={50} outerRadius={80}
                      dataKey="value" paddingAngle={2}>
                      {donaData.map((entry,i) => (
                        <Cell key={i} fill={entry.color}/>
                      ))}
                    </Pie>
                    <Tooltip formatter={(v,n) => [fmtN(v), n]} contentStyle={{borderRadius:10,fontSize:12}}/>
                  </PieChart>
                </ResponsiveContainer>
                <div className="ar-dona-leyenda">
                  {donaData.map((d,i) => (
                    <div key={i} className="ar-dona-item">
                      <span style={{background:d.color}}/>
                      {d.name}: <strong>{fmtN(d.value)}</strong>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="ar-no-data">Sin datos</div>
            )}
          </div>
        </div>

        {/* ════ GRÁFICAS FILA 2 ════ */}
        <div className="ar-graficas-row">
          {/* Área acumulado */}
          <div className="ar-card ar-card--wide">
            <div className="ar-card__head">
              <h3>Ingresos acumulados</h3>
              <span className="ar-card__sub">Tendencia del período</span>
            </div>
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={acumData} margin={{top:4,right:8,left:0,bottom:0}}>
                <defs>
                  <linearGradient id="gradVerde" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%"  stopColor="#4db88a" stopOpacity={0.25}/>
                    <stop offset="95%" stopColor="#4db88a" stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(130,216,179,.12)"/>
                <XAxis dataKey="dia" tickFormatter={fmtDia} tick={{fontSize:11,fill:'#5a6a63'}} tickLine={false}/>
                <YAxis tick={{fontSize:11,fill:'#5a6a63'}} tickLine={false} axisLine={false}
                  tickFormatter={v => 'S/.'+v.toLocaleString()}/>
                <Tooltip formatter={v => [fmtS(v),'Acumulado']} labelFormatter={fmtDia}
                  contentStyle={{borderRadius:10,border:'1px solid #d4f4e8',fontSize:12}}/>
                <Area type="monotone" dataKey="acumulado" stroke="#4db88a" strokeWidth={2.5}
                  fill="url(#gradVerde)" dot={false}/>
              </AreaChart>
            </ResponsiveContainer>
          </div>

          {/* Métodos de pago */}
          <div className="ar-card">
            <div className="ar-card__head"><h3>Métodos de pago</h3></div>
            <div className="ar-metodos-lista">
              {(datos.por_metodo||[]).length === 0 && <div className="ar-no-data">Sin datos</div>}
              {(datos.por_metodo||[]).map((m,i) => (
                <div key={i} className="ar-metodo-item">
                  <div className="ar-metodo-item__info">
                    <strong>{m.metodo || 'otro'}</strong>
                    <span>{fmtN(m.total)} pedidos</span>
                  </div>
                  <div className="ar-metodo-item__bar-wrap">
                    <div className="ar-metodo-item__bar"
                      style={{width: datos.kpi.total_pedidos > 0 ? (m.total/datos.kpi.total_pedidos*100)+'%' : '0%'}}/>
                  </div>
                  <div className="ar-metodo-item__monto">{fmtS(m.ingresos)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ════ TOP PRODUCTOS ════ */}
        <div className="ar-card">
          <div className="ar-card__head">
            <h3>Top productos</h3>
            <span className="ar-card__sub">Por ingresos en el período</span>
          </div>
          {datos.top_productos.length === 0 ? (
            <div className="ar-no-data">Sin ventas en este período</div>
          ) : (
            <div className="ar-top-tabla-wrap">
              <table className="ar-tabla">
                <thead>
                  <tr><th>#</th><th>Producto</th><th>Ventas</th><th>Ingresos</th><th>P. promedio</th><th>% Total</th></tr>
                </thead>
                <tbody>
                  {datos.top_productos.map((p,i) => (
                    <tr key={i} className="ar-tr">
                      <td><span className="ar-rank">{i+1}</span></td>
                      <td>
                        <div>
                          <strong className="ar-prod-titulo">{p.titulo}</strong>
                          {p.recurso_categoria && <span className="ar-prod-cat">{p.recurso_categoria}</span>}
                        </div>
                      </td>
                      <td><strong>{fmtN(p.ventas)}</strong></td>
                      <td><strong style={{color:'#4db88a'}}>{fmtS(p.ingresos)}</strong></td>
                      <td>{fmtS(p.precio_prom)}</td>
                      <td>
                        <div className="ar-pct-wrap">
                          <div className="ar-pct-bar" style={{width:p.pct+'%'}}/>
                          <span>{p.pct}%</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* ════ TABLA DETALLE ════ */}
        <div className="ar-card">
          <div className="ar-card__head">
            <h3>Detalle de pedidos</h3>
            <div style={{display:'flex',gap:'.6rem',alignItems:'center'}}>
              <span className="ar-card__sub">{pedidosFiltrados.length} pedidos</span>
              <div className="ar-search-mini">
                <IconSearch/>
                <input type="text" placeholder="Buscar…" value={busTabla}
                  onChange={e=>{setBusTabla(e.target.value);setPagina(1);}}/>
                {busTabla && <button onClick={()=>setBusTabla('')}><IconClose/></button>}
              </div>
            </div>
          </div>
          <div className="ar-tabla-wrap">
            <table className="ar-tabla">
              <thead>
                <tr><th>Código</th><th>Cliente</th><th>Producto</th><th>Monto</th><th>Estado</th><th>Método</th><th>Fecha</th></tr>
              </thead>
              <tbody>
                {pedidosPag.length === 0 ? (
                  <tr><td colSpan="7" className="ar-empty-row">Sin pedidos en este período</td></tr>
                ) : pedidosPag.map(p => (
                  <tr key={p.id} className="ar-tr">
                    <td><span className="ar-codigo">{p.codigo}</span></td>
                    <td>
                      <div>
                        <strong style={{fontSize:'.85rem'}}>{p.nombre}</strong>
                        <span style={{display:'block',fontSize:'.72rem',color:'#5a6a63'}}>{p.email}</span>
                      </div>
                    </td>
                    <td><span style={{fontSize:'.83rem'}}>{p.recurso_titulo}</span></td>
                    <td>
                      <strong style={{color:p.estado==='validado'?'#4db88a':'#111614'}}>
                        {fmtS(p.monto)}
                      </strong>
                      {p.descuento_puntos > 0 && (
                        <span style={{display:'block',fontSize:'.68rem',color:'#4db88a'}}>
                          − {fmtS(p.descuento_puntos)} pts
                        </span>
                      )}
                    </td>
                    <td>
                      <span className="ar-estado" style={{
                        background: COLORES_ESTADO[p.estado] + '22',
                        color: COLORES_ESTADO[p.estado] || '#5a6a63',
                      }}>
                        {ESTADO_LABEL[p.estado] || p.estado}
                      </span>
                    </td>
                    <td><span style={{fontSize:'.78rem',color:'#5a6a63'}}>{p.metodo_pago||'—'}</span></td>
                    <td><span style={{fontSize:'.78rem',color:'#5a6a63'}}>{p.created_at?.split('T')[0]||p.created_at||'—'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Paginación tabla */}
          {totalPag > 1 && (
            <div className="ar-paginacion">
              <span>Pág. {paginaSeg} de {totalPag}</span>
              <div className="ar-pag-btns">
                <button className="ar-pag-btn" onClick={()=>setPagina(p=>Math.max(1,p-1))} disabled={paginaSeg===1}><IconChevL/></button>
                {Array.from({length:Math.min(5,totalPag)},(_,i)=>{
                  const p = Math.max(1,Math.min(paginaSeg-2,totalPag-4))+i;
                  return (<button key={p} className={'ar-pag-num '+(p===paginaSeg?'ar-pag-num--active':'')} onClick={()=>setPagina(p)}>{p}</button>);
                })}
                <button className="ar-pag-btn" onClick={()=>setPagina(p=>Math.min(totalPag,p+1))} disabled={paginaSeg===totalPag}><IconChevR/></button>
              </div>
            </div>
          )}
        </div>
      </>)}
    </div>
  );
}